import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { TransactionOverview } from '../TransactionOverview'
import { Token } from '@/domain/types/Token'
import { testIds } from '@/ui/utils/testIds'

export interface TransactionOverviewStakedInFarmProps {
  token: Token
  amount: NormalizedNumber
  farmName: string
}

export function TransactionOverviewStakedInFarm({ token, amount, farmName }: TransactionOverviewStakedInFarmProps) {
  return (
    <TransactionOverview.TokenAmountOutcome
      token={token}
      amount={amount}
      postFix={`Staked in ${farmName}`}
      amountDataTestId={testIds.farmDetails.stakeDialog.transactionOverview.outcome}
    />
  )
}
